import buttonPress1 from './zapsplat_multimedia_button_press_plastic_click_001_36868.mp3'
import buttonPress2 from './zapsplat_multimedia_button_press_plastic_click_002_36869.mp3'
import buttonPress3 from './zapsplat_multimedia_button_press_plastic_click_003_36870.mp3'
import buttonPress4 from './multimedia_button_click_008.mp3'
import typewriter1 from './zapsplat_office_electronic_typewriter_chassis_creak_movement_stress_brother_ax_450_001_33703.mp3'

// {
//   data: something,
//   volume: 0.5
// }

export default {
  buttonPress1: {
    data: buttonPress1
  },
  buttonPress2: {
    data: buttonPress2
  },
  buttonPress3: {
    data: buttonPress3
  },
  buttonPress4: {
    data: buttonPress4
  },
  typewriter1: {
    data: typewriter1
  }
}
